import styled from "styled-components";

export const CMForgotPasswordModal = styled.div((props) => ({
	minWidth: "330px",
	minHeight: "auto",
	padding: '2rem',
	backgroundColor: "white",
	borderRadius: "8px",
	border: 'solid black 2px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'left',

	"& .error": {
		color: "#a80000",
		fontSize: '0.8rem'
	},

	"& .form-container": {
		padding: '1rem 0',
		width:'100%',
		display: "flex",
		flexDirection: 'column',
		justifyContent: 'left',
		alignItems: "left"
	},

	'& > div': {
		padding: '1rem 0'
	},

	'& .title': {
		textAlign: 'center',
		borderBottom: `solid 1px #a80000`
	},

	'& .button-container': {
		marginTop: 0,

		'& button': {
			marginRight: '1rem',
			textTransform: 'unset',
		}
	},

	[`@media ${props.theme.breakpoints.lg}`]: {
		overflow: "auto",
	},
	[`@media ${props.theme.breakpoints.xs}`]: {
		minWidth: "auto",
		width: "250px",
		overflow: "auto",
	},
}))
export const CMDivLogin = styled.div`
  width: 100%;
  display: flex;
  align-itemns: flex-end;
  flex-direction: column;
  text-align: left;

  & label {
    color: #6e6d6d;
  }
	& .countMessage {
	color: gray;
	margin-top: 0.8em;
	text-align:center;
  	}
	& .buttonTopNone {
	margin-top: 0.8em;
  	}
  & .password-field {
    & span {
      position: relative;
      width: 100%;
      background: transparent;
      justify-content: left;
    }
  }
`;